import { variation } from 'ember-launch-darkly';
import { DateTime } from 'luxon';

export const VAULT_RADAR_TENANT_STATES = {
  ACTIVE_BETA: 'ACTIVE_BETA',
  ACTIVE_PAID: 'ACTIVE_PAID',
  ACTIVE_TRIAL: 'ACTIVE_TRIAL',
  NEW_BETA: 'NEW_BETA',
  NEW_PAID: 'NEW_PAID',
  SETUP_REQUIRED: 'SETUP_REQUIRED',
  NEW_TRIAL: 'NEW_TRIAL',
  CLAIMED_TENANT: 'CLAIMED_TENANT',
  DELETED_TENANT: 'DELETED_TENANT',
  TRIAL_ENDED: 'TRIAL_ENDED',
  SERVICE_CUTOFF: 'SERVICE_CUTOFF',
  DISABLED: 'DISABLED',
};

export const TENANT_TYPE = {
  BETA: 'BETA',
  INTERNAL: 'INTERNAL',
  POC: 'POC',
  CUSTOMER: 'CUSTOMER',
  STANDARD: 'STANDARD',
  TRIAL: 'TRIAL',
};

export const TENANT_STATE = {
  NEW: 'NEW',
  PROVISIONED: 'PROVISIONED',
  DELINQUENT: 'DELINQUENT',
  DELAYED_DEPROVISIONING: 'DELAYED_DEPROVISIONING',
  DEPROVISIONING: 'DEPROVISIONING',
  DELETED: 'DELETED',
};

export const isVaultRadarDeleted = (tenantState) => {
  const serviceCutoffStates = [
    TENANT_STATE.DEPROVISIONING,
    TENANT_STATE.DELETED,
  ];
  return serviceCutoffStates.includes(tenantState);
};

export const isVaultRadarTrial = (tenantType) => {
  const trialTenantStates = [TENANT_TYPE.BETA, TENANT_TYPE.TRIAL];
  return trialTenantStates.includes(tenantType);
};

export const isVaultRadarPaid = (tenantType) => {
  const paidTenantStates = [
    TENANT_TYPE.CUSTOMER,
    TENANT_TYPE.STANDARD,
    TENANT_TYPE.INTERNAL,
    TENANT_TYPE.POC,
  ];
  return paidTenantStates.includes(tenantType);
};

export const getVaultRadarServiceCardBadgeText = (
  strings,
  tenantData,
  tenantLoading,
  intl
) => {
  const { type, trialExpiresAt } = tenantData;
  const defaultType = variation('hcp-vault-radar-user-interface-show-billing')
    ? TENANT_TYPE.TRIAL
    : TENANT_TYPE.BETA;
  const currentType = type || defaultType;

  if (tenantLoading) {
    return strings;
  }

  if (currentType === TENANT_TYPE.BETA) {
    strings.releaseBadge = intl.t('nav.project.radar-beta-badge');
    return strings;
  }

  if (currentType !== TENANT_TYPE.TRIAL) {
    return strings;
  }

  if (!trialExpiresAt) {
    strings.releaseBadge = intl.t('service-card.radar-active-trial-badge-text');
    return strings;
  }

  const expirationInDays = Math.ceil(
    DateTime.fromJSDate(new Date(trialExpiresAt))
      .diff(DateTime.now(), ['days'])
      .toObject().days
  );

  if (expirationInDays <= 0) {
    strings.releaseBadge = intl.t(
      'service-card.radar-inactive-trial-badge-text'
    );
    return strings;
  }

  strings.releaseBadge = intl.t(
    'service-card.radar-active-trial-badge-text-with-days',
    {
      days: expirationInDays,
    }
  );

  return strings;
};
